import { render } from "./SC_cot_info_route.vue?vue&type=template&id=77977801"
import script from "./SC_cot_info_route.vue?vue&type=script&lang=js"
export * from "./SC_cot_info_route.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\sisco\\Documents\\Compras\\SC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__